import { PortfolioItemStatus, PortfolioItemType } from '@graphql/generated';
import { BusinessEntityTranslation, BusinessEntityWithTranslation, EntityWithTranslationManager } from '@xFrame4/business/BusinessEntityWithTranslation';
import { ImageInfo, imageInfoGraphQlDetails } from '@xFrame4/business/Constants';
import PortfolioCategory from './PortfolioCategory';

export class PortfolioItemTranslation extends BusinessEntityTranslation
{
    title: string = '';
    subtitle: string = '';
    title2: string = '';
    subtitle2: string = '';
    slug: string = '';
    seoTitle: string = '';
    seoDescription: string = '';
    seoKeywords: string = '';    
}

export class PortfolioItem extends BusinessEntityWithTranslation<PortfolioItemTranslation>
{
    protected createTranslationObject = () => new PortfolioItemTranslation();

    category!: PortfolioCategory;
    type: PortfolioItemType = PortfolioItemType.Image;
    status: PortfolioItemStatus = PortfolioItemStatus.Enabled;
    orderNo!: number;
    image: ImageInfo | null = null;
    videoUrl: string | null = null;
    
    static manager: EntityWithTranslationManager<PortfolioItemTranslation, PortfolioItem> = new EntityWithTranslationManager<PortfolioItemTranslation, PortfolioItem>({
        name: 'PortfolioItem',
        createEntity: () => new PortfolioItem(),
        fields: [
            { name: 'category', isRequiredInput: true, inputName: 'categoryId', inputProperty: 'category.id', relatedManager: PortfolioCategory.manager },
            { name: 'type', isRequiredInput: true },
            { name: 'status', isRequiredInput: true },
            { name: 'orderNo' },
            { name: 'image', inputProperty: 'imageFile', customGraphQl: imageInfoGraphQlDetails },
            { name: 'videoUrl', inputName: 'video', inputProperty: 'videoFile' },
        ],
        translationFields: [
            { name: 'title' },
            { name: 'subtitle' },
            { name: 'title2' },
            { name: 'subtitle2' },
            { name: 'slug' },
            { name: 'seoTitle' },
            { name: 'seoDescription' },
            { name: 'seoKeywords' }
        ],
        graphQlQueryAlias: 'portfolioItems',
    });
}

export default PortfolioItem;